module.exports = __webpack_public_path__ + "img/fb-logo.97cfcb5a.png";